import React, { useState, useEffect } from 'react';
import { Table, Button, Form, Row, Col, Container } from 'react-bootstrap';

const GroupedTable = () => {

  const [groupedData, setGroupedData] = useState([]);
  // Initialisieren der Zustände
  const [data, setData] = useState([]);
  // const data = 
  const [sortConfig, setSortConfig] = useState({ key: 'result', direction: 'descending' });
  const [filterCategory, setFilterCategory] = useState('');
  const [filterApp, setFilterApp] = useState('WA');
  const appNames = ['WA', 'Hoop', 'Clubs', 'Ribbon', 'Ball', 'Rope'];
  // // Daten aus localStorage laden, wenn die Komponente gemountet wird
  // useEffect(() => {
  //   const storedData = JSON.parse(localStorage.getItem('data')) || [];
  //   setData(storedData);
  // }, []);

  // Funktion zum Laden der Daten aus dem localStorage
  const loadData = () => {
    const storedData = localStorage.getItem('data'); // Holen der Daten aus localStorage

    if (storedData) {
      setData(JSON.parse(storedData)); // Wenn Daten vorhanden sind, speichere sie im Zustand
      const grouped = data.reduce((acc, item) => {
        const name = item.name;
        if (!acc[name]) {
          acc[name] = { name, category: item.category, R1: { app: '', score: 0 }, R2: { app: '-', score: 0 }, totalScore: 0 };
        }
        if (item.round === 'R1') {
          acc[name].R1.Category_R = item.Category_R;
          acc[name].R1.app = item.app;
          acc[name].R1.score = item.score === 'nan' ? 0 : item.score;
        } else if (item.round === 'R2') {
          acc[name].R2.Category_R = item.Category_R;
          acc[name].R2.app = item.app;
          acc[name].R2.score = item.score === 'nan' ? 0 : item.score;
        }
        // Summe der beiden Scores
        acc[name].totalScore = (parseFloat(acc[name].R1.score) + parseFloat(acc[name].R2.score)).toFixed(1);
        return acc;
      }, {});
  
      // Umwandeln des Objekts in ein Array und Absteigend sortieren
      const groupedArray = Object.values(grouped).sort((a, b) => b.totalScore - a.totalScore);
      setGroupedData(groupedArray);
      console.log(grouped);
    } else {
      console.log('Keine Daten im localStorage gefunden');
    }
  };

  // Filtert die gruppierten Daten basierend auf Kategorie und App
  const filteredGroupedData = groupedData.filter((entry) =>
    entry.category.toLowerCase().includes(filterCategory.toLowerCase())
  );
  // Filtert die Daten basierend auf Kategorie und App
//   const filteredData = data.filter((entry) =>(
//     entry.category.toLowerCase().includes(filterCategory.toLowerCase()) &&
//     entry.app.toLowerCase().includes(filterApp.toLowerCase()))
// );  

function filterData(filterApp) {
  return data.filter((entry) => 
    entry.category.toLowerCase().includes(filterCategory.toLowerCase()) &&
    entry.app.toLowerCase().includes(filterApp.toLowerCase()) &&
    entry.score != 'nan'
  );
}
  
  // Funktionen zum Filtern der Daten
  const handleCategoryFilterChange = (e) => {
    setFilterCategory(e.target.value);
  };

  // Rangberechnung
  const getRank = (index) => {
    return index + 1; // Rang basierend auf der Position in der Liste
  };

  // useEffect(() => {
  //   // Gruppierung der Daten nach Name
  //   const grouped = data.reduce((acc, item) => {
  //     const name = item.name;
  //     if (!acc[name]) {
  //       acc[name] = { name, R1: { app: '', score: 0 }, R2: { app: '', score: 0 }, totalScore: 0 };
  //     }
  //     if (item.round === 'R1') {
  //       acc[name].R1.app = item.app;
  //       acc[name].R1.score = item.score;
  //     } else if (item.round === 'R2') {
  //       acc[name].R2.app = item.app;
  //       acc[name].R2.score = item.score;
  //     }
  //     // Summe der beiden Scores
  //     acc[name].totalScore = acc[name].R1.score + acc[name].R2.score;
  //     return acc;
  //   }, {});

  //   // Umwandeln des Objekts in ein Array und Absteigend sortieren
  //   const groupedArray = Object.values(grouped).sort((a, b) => b.totalScore - a.totalScore);
  //   setGroupedData(groupedArray);
  // }, []);

  return (
    <div>
            <Container fluid>

           <h3><b>{filterCategory}</b> - Results</h3>
      <Row>
        <Button onClick={loadData} variant="primary">
          Refresh table
        </Button>
      </Row>
       <Row>
         <Col>
           {/* Filter nach Kategorie */}
           <Form.Group>
             <Form.Label>Choose Category</Form.Label>
             <Form.Control
              type="text"
              value={filterCategory}
              onChange={handleCategoryFilterChange}
              placeholder="Suche nach Kategorie"
            />
          </Form.Group>
        </Col>
      </Row>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Apps</th>
            <th>Category</th>
            <th>R1</th>
            <th>R2</th>
            <th>Total Score</th>
          </tr>
        </thead>
        <tbody>
          {filteredGroupedData.map((entry, index) => (
            <tr key={entry.name}>
              <td><b>{getRank(index)}.</b></td>
              <td>{entry.name}</td>
              <td>{entry.R1.app} | {entry.R2.app}</td>
              <td>{entry.category}</td>
              <td>{entry.R1.score}</td>
              <td>{entry.R2.score}</td>
              <td><b>{entry.totalScore}</b></td>
            </tr>
          ))}
        </tbody>
        </Table>
        {appNames.map((appName) => (
        <div key={appName}>
          <h4>{appName}</h4>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              {filterData(appName).sort((a, b) => b.score - a.score).map((entry, index) => (
                <tr key={entry.name}>
                  <td>{getRank(index)}.</td>
                  <td>{entry.name}</td>
                  <td>{entry.score}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ))}
    </Container>
    </div>
  );
};

export default GroupedTable;


// const ResultTable = () => {
//   // Initialisieren der Zustände
//   const [data, setData] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: 'result', direction: 'descending' });
//   const [filterCategory, setFilterCategory] = useState('');
//   const [filterApp, setFilterApp] = useState('');

//   // // Daten aus localStorage laden, wenn die Komponente gemountet wird
//   // useEffect(() => {
//   //   const storedData = JSON.parse(localStorage.getItem('data')) || [];
//   //   setData(storedData);
//   // }, []);

//   // Funktion zum Laden der Daten aus dem localStorage
//   const loadData = () => {
//     const storedData = localStorage.getItem('data'); // Holen der Daten aus localStorage

//     if (storedData) {
//       setData(JSON.parse(storedData)); // Wenn Daten vorhanden sind, speichere sie im Zustand
//     } else {
//       console.log('Keine Daten im localStorage gefunden');
//     }
//   };

//   // Funktion zum Sortieren der Daten
//   const sortedData = React.useMemo(() => {
//     const sorted = [...data];
//     sorted.sort((a, b) => {
//       if (a[sortConfig.key] < b[sortConfig.key]) {
//         return sortConfig.direction === 'ascending' ? -1 : 1;
//       }
//       if (a[sortConfig.key] > b[sortConfig.key]) {
//         return sortConfig.direction === 'ascending' ? 1 : -1;
//       }
//       return 0;
//     });
//     return sorted;
//   }, [data, sortConfig]);

//   // Filtert die Daten basierend auf Kategorie und App
//   const filteredData = sortedData.filter((entry) =>
//     entry.category.toLowerCase().includes(filterCategory.toLowerCase()) &&
//     entry.app.toLowerCase().includes(filterApp.toLowerCase())
//   );

//   // Sortiert die Tabelle nach der `result` Spalte
//   const requestSort = (key) => {
//     let direction = 'ascending';
//     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
//       direction = 'descending';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Funktionen zum Filtern der Daten
//   const handleCategoryFilterChange = (e) => {
//     setFilterCategory(e.target.value);
//   };

//   const handleAppFilterChange = (e) => {
//     setFilterApp(e.target.value);
//   };

//   // Rang berechnen: Ergebnis absteigend sortieren
//   const getRank = (index) => {
//     return index + 1;
//   };

//   return (
//     <div>
      // <h3>Results</h3>
      // <Row>
      //   <Button onClick={loadData} variant="primary">
      //     Refresh table
      //   </Button>
      // </Row>
      // <Row>
      //   <Col>
      //     {/* Filter nach Kategorie */}
      //     <Form.Group>
      //       <Form.Label>Filter nach Kategorie</Form.Label>
      //       <Form.Control
      //         type="text"
      //         value={filterCategory}
      //         onChange={handleCategoryFilterChange}
      //         placeholder="Suche nach Kategorie"
      //       />
      //     </Form.Group>
      //   </Col>
      //   <Col>
      //     {/* Filter nach App */}
      //     <Form.Group>
      //       <Form.Label>Filter nach App</Form.Label>
      //       <Form.Control
      //         type="text"
      //         value={filterApp}
      //         onChange={handleAppFilterChange}
      //         placeholder="Suche nach App"
      //       />
      //     </Form.Group>
      //   </Col>
      // </Row>
//       <Row>
//         {/* Tabelle */}
//         <Table striped bordered hover responsive>
//           <thead>
//             <tr>
//               <th onClick={() => requestSort('id')}>ID</th>
//               <th onClick={() => requestSort('name')}>Name</th>
//               <th onClick={() => requestSort('category')}>Kategorie</th>
//               <th onClick={() => requestSort('app')}>App</th>
//               <th onClick={() => requestSort('DA')}>DA</th>
//               <th onClick={() => requestSort('DE')}>DE</th>
//               <th onClick={() => requestSort('A')}>A</th>
//               <th onClick={() => requestSort('E')}>E</th>
//               <th onClick={() => requestSort('Minus')}>Minus</th>
//               <th onClick={() => requestSort('score')}>Score</th>
//               <th>Rang</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredData.map((entry, index) => (
//               <tr key={entry.id}>
//                 <td>{entry.id}</td>
//                 <td>{entry.name}</td>
//                 <td>{entry.category}</td>
//                 <td>{entry.app}</td>
//                 <td>{entry.DA}</td>
//                 <td>{entry.DE}</td>
//                 <td>{entry.A}</td>
//                 <td>{entry.D}</td>
//                 <td>{entry.Minus}</td>
//                 <td>{entry.score}</td>
//                 <td>{getRank(index)}</td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       </Row>




//     </div>
//   );
// };
// export default ResultTable;
